import { buildNumberValue } from '../CreateSendoutDrawer/SendoutForm/SendoutForm.utils';

export const FORM_FIELDS_MAP = {
  Status: {
    key: 'status'
  },
  EstimatedFeeAmount: {
    key: 'estimatedFeeAmount'
  },
  AccountableRecruiter: {
    key: 'accountableRecruiter'
  },
  CandidateRecruiter: {
    key: 'candidateRecruiter'
  },
  HiringAuthority: {
    key: 'hiringAuthority'
  },
  DeclinationDetails: {
    key: 'declinationDetails'
  }
};

export const SENDOUT_DETAILS_UPDATE_FIELDS_MAP = {
  Status: {
    key: FORM_FIELDS_MAP.Status.key,
    paramKey: 'statusId',
    outboundAccesor: 'id'
  },
  EstimatedFeeAmount: {
    key: FORM_FIELDS_MAP.EstimatedFeeAmount.key,
    paramKey: 'feeAmount',
    outboundAccesor: buildNumberValue
  },
  AccountableRecruiter: {
    key: FORM_FIELDS_MAP.AccountableRecruiter.key,
    paramKey: 'jobOrderAccountableId',
    outboundAccesor: 'id'
  },
  CandidateRecruiter: {
    key: FORM_FIELDS_MAP.CandidateRecruiter.key,
    paramKey: 'candidateAccountableId',
    outboundAccesor: 'id'
  },
  HiringAuthority: {
    key: FORM_FIELDS_MAP.HiringAuthority.key,
    paramKey: 'hiringAuthorityId',
    outboundAccesor: 'id'
  }
};
